import { computed, Injectable } from "@angular/core";

import { IPageStateStorage } from "../../interfaces/page-state-storage.interface";
import { storageSignalTree } from "../../functions/storage-signal-tree.function";

@Injectable({
  providedIn: 'root'
})
export class PageStateLocalStorageService {

    private __tree$$ = storageSignalTree<IPageStateStorage>(
        'page-state',
        {} as IPageStateStorage,
        {
            type: 'session',
            debounce: 300,
            ttl: 86400000
        }
    );

    headerData$$ = this.__tree$$.headerData;
}